import { FC, ReactNode } from "react";
import { usePaypingContext } from "@payping/web-components";

interface Props {
  mobile: ReactNode;
  desktop: ReactNode;
}
export const DetectMobileView: FC<Props> = (props) => {
  const { desktop, mobile } = props;
  const { breakpoints } = usePaypingContext();
  const { lg } = breakpoints;

  return lg ? desktop : mobile;
};
